import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import { TaskCard } from "./TaskCard";
import { STATUS_COLUMNS, STATUS_COLORS, STATUS_LABELS, STAGE_STATUS } from "./constants";

export const ProjectBoard = ({ tasks, stages, view, onDragEnd, onUpdateFields, teamMembers }) => {
  const tasksByStage = {};
  stages.forEach(s => { tasksByStage[s.name] = []; });
  tasks.forEach(t => {
    const key = t.stage || t.workflow_stage || "Unassigned";
    if (!tasksByStage[key]) tasksByStage[key] = [];
    tasksByStage[key].push(t);
  });

  const tasksByStatus = {};
  STATUS_COLUMNS.forEach(s => { tasksByStatus[s] = []; });
  tasks.forEach(t => {
    const normalized = (t.status || "todo").toLowerCase().replace(" ", "_");
    const key = STATUS_COLUMNS.includes(normalized) ? normalized : "todo";
    tasksByStatus[key].push(t);
  });

  return (
    <div className="p-4 h-full" data-testid="board-tab">
      <DragDropContext onDragEnd={onDragEnd}>
        <div className="flex gap-3 h-full overflow-x-auto pb-4">
          {view === "stage" ? (
            stages?.map(s => {
              const sc = STAGE_STATUS[s.status] || STAGE_STATUS.pending;
              const stageTasks = tasksByStage[s.name] || [];
              return (
                <div key={s.name} className="w-72 shrink-0 flex flex-col bg-white/60 rounded-xl border border-border/40 overflow-hidden" data-testid={`kanban-stage-${s.name.toLowerCase()}`}>
                  <div className={`px-3.5 py-2.5 border-b ${sc.border} ${sc.light} flex items-center justify-between`}>
                    <div className="flex items-center gap-2"><div className={`w-2 h-2 rounded-full ${sc.bg}`} /><span className={`text-xs font-bold ${sc.text}`}>{s.name}</span></div>
                    <span className="text-[10px] font-bold text-foreground/45 bg-foreground/[0.04] px-1.5 py-0.5 rounded-md">{stageTasks.length}</span>
                  </div>
                  <Droppable droppableId={s.name}>
                    {(provided, snapshot) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}
                        className={`flex-1 overflow-y-auto p-2 min-h-[80px] transition-colors ${snapshot.isDraggingOver ? "bg-[#014d7d]/[0.03]" : ""}`}>
                        {stageTasks?.map((t, i) => <TaskCard key={t.id} task={t} index={i} onUpdate={onUpdateFields} teamMembers={teamMembers} />)}
                        {provided.placeholder}
                        {stageTasks.length === 0 && !snapshot.isDraggingOver && <p className="text-[10px] text-foreground/45 text-center py-6">No tasks</p>}
                      </div>
                    )}
                  </Droppable>
                </div>
              );
            })
          ) : (
            STATUS_COLUMNS?.map(status => {
              const sc = STATUS_COLORS[status];
              const colTasks = tasksByStatus[status] || [];
              return (
                <div key={status} className="w-72 shrink-0 flex flex-col bg-white/60 rounded-xl border border-border/40 overflow-hidden" data-testid={`kanban-status-${status}`}>
                  <div className={`px-3.5 py-2.5 border-b ${sc.border} ${sc.bg} flex items-center justify-between`}>
                    <div className="flex items-center gap-2"><div className={`w-2 h-2 rounded-full ${sc.dot}`} /><span className={`text-xs font-bold ${sc.text}`}>{STATUS_LABELS[status]}</span></div>
                    <span className="text-[10px] font-bold text-foreground/45 bg-foreground/[0.04] px-1.5 py-0.5 rounded-md">{colTasks.length}</span>
                  </div>
                  <Droppable droppableId={status}>
                    {(provided, snapshot) => (
                      <div ref={provided.innerRef} {...provided.droppableProps}
                        className={`flex-1 overflow-y-auto p-2 min-h-[80px] transition-colors ${snapshot.isDraggingOver ? "bg-[#014d7d]/[0.03]" : ""}`}>
                        {colTasks?.map((t, i) => <TaskCard key={t.id} task={t} index={i} onUpdate={onUpdateFields} teamMembers={teamMembers} />)}
                        {provided.placeholder}
                        {colTasks.length === 0 && !snapshot.isDraggingOver && <p className="text-[10px] text-foreground/45 text-center py-6">No tasks</p>}
                      </div>
                    )}
                  </Droppable>
                </div>
              );
            })
          )}
        </div>
      </DragDropContext>
    </div>
  );
};
